// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__JZEAB","actions":"GroupTable_actions__KHE9N","deleteModalFooter":"GroupTable_deleteModalFooter__syvTG"};